module.exports = __webpack_public_path__ + "static/media/suv.b4cbb06c.svg";